<template>
    <div
        style=" height: calc(100vh - 60px); display: flex;flex-direction: column;overflow-y: auto;padding: 0px 20px;box-sizing: border-box;">
        <h4 style="margin-bottom: 10px;">Client Datas</h4>
        <!-- Pending Reply Alert -->
        <div 
            v-if="pendingReplyCount > 0"
            style="padding: 10px; background-color: #fef0f0; border: 1px solid #fde2e2; border-radius: 4px; margin-bottom: 10px; display: flex; align-items: center;">
            <i class="el-icon-warning" style="color: #f56c6c; margin-right: 8px; font-size: 16px;"></i>
            <span style="color: #f56c6c; font-size: 14px;">There are {{ pendingReplyCount }} earlier emails pending reply</span>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="Student Applications" name="first">
                <h4>Contact Info</h4>
                <div v-if="contacts.length > 0" class="table-container">
                    <div v-for="(contact, index) in contacts" :key="index" class="table-item">
                        <p> Name: {{ contact.contact_lastName + contact.contact_givenName }}</p>
                        <p> Email: {{ contact.contact_email }}</p>
                        <p> Account: {{ contact.account_name }}</p>
                        <p> Country: {{ contact.account_country }}</p>
                    </div>
                </div>
                <h4>Student Info</h4>
                <div v-if="students.length > 0" class="table-container">
                    <div v-for="(student, index) in students" :key="index" class="table-item">
                        <p> Name: {{ student.student_lastName_pinyin + student.student_givenName_pinyin }}</p>
                        <p> Email: {{ student.student_email }}</p>
                        <p> Account: {{ student.account_name }}</p>
                        <p> AccountCountry: {{ student.account_country }}</p>
                        <p> Student ID: {{ disguiseId(student._id.$id) }}
                            <el-button size="mini" type="text" @click="copyToClipboard(student._id.$id)" style="margin-left: 5px;">
                                <i class="el-icon-copy-document"></i>
                            </el-button>
                        </p>
                    </div>
                </div>
                <h4>Applications</h4>
                <div v-if="applications.length > 0" class="table-container">
                    <div v-for="(application, index) in applications" :key="index" class="table-item">
                        <p> Project: {{ application.application_project }}</p>
                        <p> Status: {{ application.application_status }}</p>
                        <p> APP ID: {{ disguiseId(application._id.$id) }}
                            <el-button size="mini" type="text" @click="copyToClipboard(application._id.$id)" style="margin-left: 5px;">
                                <i class="el-icon-copy-document"></i>
                            </el-button>
                        </p>
                        <el-button size="mini" type="primary" @click="showApplicationDetails(application)" style="margin-top: 8px;">
                            More Details
                        </el-button>
                    </div>
                </div>
                <h4>Account Apps</h4>
                <div v-if="accountApps && Object.keys(accountApps).length > 0" class="table-container">
                    <div v-for="(contacts, projectCode) in accountApps" :key="projectCode" class="table-item">
                        <p>Project Code: {{ projectCode }}</p>
                        <p>Contacts: {{ contacts.join(', ') }}</p>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="History" name="second">
                <div class="table-container">
                    <div v-for="(emailInfo, index) in mailHistoryData" :key="index" class="table-item">
                        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 5px;">
                            <el-tag :type="getStatusTagType(emailInfo)" size="small">{{ getStatusText(emailInfo) }}</el-tag>
                        </div>
                        <p class="email" style="margin: 0;">Sender: {{ emailInfo.fromName }} ({{ emailInfo.from }})</p>
                        <p class="time" v-if="emailInfo.sender" style="margin-top: 5px;">By {{
                            emailInfo.sender?.user_lastName +
                            " " +
                            emailInfo.sender?.user_givenName }}</p>

                        <p class="time">Date: {{ formatMailDate(emailInfo) }}</p>
                        <p class="email">Receiver: {{ emailInfo.to }}</p>
                        <p class="subject">Subject: {{ emailInfo.subject }}</p>
                        <p class="subject" style="cursor: pointer;">Content: <span style="color: red;"
                                @click="showEmailContent(emailInfo)">点击查看内容</span></p>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <el-dialog :visible.sync="showContentDialog" title="Email Content" width="65%">
            <div v-html="emailContent">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showContentDialog = false">Close</el-button>
                <el-button 
                    type="warning" 
                    @click="setNoNeedToReply"
                    v-if="selectedEmailForContent && (!selectedEmailForContent.reply_status || selectedEmailForContent.reply_status !== -1)"
                    :loading="settingNoReply">
                    No Need to Reply
                </el-button>
            </div>
        </el-dialog>
        
        <el-dialog :visible.sync="showDetailsDialog" title="Application Details" width="70%">
            <div v-loading="loadingDetails">
                <!-- 加载状态 -->
                <div v-if="loadingDetails">
                    <p style="text-align: center; color: #999; margin: 20px 0;">Loading application details...</p>
                </div>
                
                <!-- 数据内容 -->
                <div v-else-if="!loadingDetails && selectedApplication">
                    <h4>Basic Information</h4>
                    <div class="details-section">
                        <p><strong>Project:</strong> {{ selectedApplication.application_project }}</p>
                        <p><strong>Status:</strong> {{ selectedApplication.application_status }}</p>
                        <p><strong>Application ID:</strong> {{ selectedApplication._id.$id }}</p>
                        <p v-if="selectedApplication.custom_exam_time"><strong>Custom Exam Time:</strong> {{ formatCustomExamTime(selectedApplication.custom_exam_time) }}</p>
                    </div>
                    
                    
                    <div v-if="applicationDetails && applicationDetails.scores && applicationDetails.scores.length > 0">
                        <h4>Scores</h4>
                        <div class="details-section">
                            <div v-for="(score, index) in applicationDetails.scores" :key="`score-${index}`" class="detail-item">
                                <p><strong>Total Score:</strong> {{ score.total_score }}</p>
                                <p><strong>Full Score:</strong> {{ score.full_score }}</p>
                                <p><strong>Event:</strong> {{ score.application_event || 'N/A' }}</p>
                                <p><strong>Mode:</strong> {{ score.mode || 'N/A' }}</p>
                                <p><strong>Score Type:</strong> {{ score.score_type || 'N/A' }}</p>
                                <p><strong>Team Code:</strong> {{ score.team_code || 'N/A' }}</p>
                                <p><strong>Date:</strong> {{ formatTimestamp(score.create_time) }}</p>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="applicationDetails && applicationDetails.awards && applicationDetails.awards.length > 0">
                        <h4>Awards</h4>
                        <div class="details-section">
                            <div v-for="(award, index) in applicationDetails.awards" :key="`award-${index}`" class="detail-item">
                                <p><strong>Award Label:</strong> {{ award.award_lable || 'N/A' }}</p>
                                <p><strong>Category:</strong> {{ award.award_category_name || 'N/A' }}</p>
                                <p><strong>Event:</strong> {{ award.application_event || 'N/A' }}</p>
                                <p><strong>Level:</strong> {{ award.award_level || 'N/A' }}</p>
                                <p><strong>Rank:</strong> {{ award.real_rank || 'N/A' }}</p>
                                <p><strong>Total Score:</strong> {{ award.total_score || 'N/A' }}</p>
                                <p><strong>Country:</strong> {{ award.country || 'N/A' }}</p>
                                <p><strong>Continent:</strong> {{ award.continent || 'N/A' }}</p>
                                <p><strong>Date:</strong> {{ formatTimestamp(award.create_time) }}</p>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="applicationDetails && applicationDetails.exerciseTests && applicationDetails.exerciseTests.length > 0">
                        <h4>Exercise Tests</h4>
                        <div class="details-section">
                            <div v-for="(test, index) in applicationDetails.exerciseTests" :key="`test-${index}`" class="detail-item">
                                <p><strong>Test Name:</strong> {{ test.test_name || 'N/A' }}</p>
                                <p><strong>Result:</strong> {{ test.test_result || 'N/A' }}</p>
                                <p><strong>Date:</strong> {{ formatTimestamp(test.create_time) }}</p>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="applicationDetails && applicationDetails.exerciseTestSigns && applicationDetails.exerciseTestSigns.length > 0">
                        <h4>Exercise Test Sign Records</h4>
                        <div class="details-section">
                            <div v-for="(sign, index) in applicationDetails.exerciseTestSigns" :key="`sign-${index}`" class="detail-item">
                                <p><strong>Project Code:</strong> {{ sign.project_code || 'N/A' }}</p>
                                <p><strong>Template Name:</strong> {{ sign.template_name || 'N/A' }}</p>
                                <p><strong>Template ID:</strong> {{ sign.template_id || 'N/A' }}</p>
                                <p><strong>Test Duration:</strong> {{ sign.test_duration }} minutes</p>
                                <p><strong>Wait Time:</strong> {{ sign.wait_time }} seconds</p>
                                <p><strong>Begin Time:</strong> {{ formatTimestamp(sign.begin_time) }}</p>
                                <p><strong>End Time:</strong> {{ formatTimestamp(sign.end_time) }}</p>
                                <p><strong>Sign Time:</strong> {{ formatTimestamp(sign.sign_time) }}</p>
                            </div>
                        </div>
                    </div>
                    
                    <!-- 空数据状态 -->
                    <div v-if="!loadingDetails && (!applicationDetails || Object.keys(applicationDetails).length === 0)">
                        <p style="text-align: center; color: #999; margin: 20px 0;">No additional details available for this application.</p>
                    </div>
                    
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showDetailsDialog = false">Close</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    getEmailHistoryByFromEmail
} from '../../api/assistant'
import {
    formatDate
} from '../../utils/date'
export default ({
    name: 'index',
    props: {
        mail_type: {
            type: String,
            default: ''
        },
        mail_id: {
            type: String,
            default: ''
        },
        clientData: {
            type: Object,
            default: {}
        }
    },
    watch: {
        clientData: {
            handler(newVal, oldVal) {
                this.handleClientData()
            },
            immediate: true
        },
        mail_id: {
            handler(newVal, oldVal) {
                this.handleMailChanged()
            },
            immediate: true
        }
    },
    data() {
        return {
            mailHistoryData: [],
            activeName: 'first',
            contacts: [],
            students: [],
            applications: [],
            accountApps: {},
            emailContent: '',
            showContentDialog: false,
            pendingReplyCount: 0,
            selectedEmailForContent: null,
            settingNoReply: false,
            showDetailsDialog: false,
            selectedApplication: null,
            applicationDetails: {},
            loadingDetails: false
        }
    },
    methods: {
        disguiseId(id) {
            if (!id || id.length < 8) return id;
            return id.substring(0, 4) + '***' + id.substring(id.length - 4);
        },
        
        async copyToClipboard(text) {
            try {
                await navigator.clipboard.writeText(text);
                this.$message.success('ID copied to clipboard');
            } catch (err) {
                // Fallback for older browsers
                const textArea = document.createElement('textarea');
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                this.$message.success('ID copied to clipboard');
            }
        },
        
        handleClick(tab, event) {
            // Handle tab click event if needed
            console.log('Tab clicked:', tab.name);
        },
        
        async showApplicationDetails(application) {
            this.selectedApplication = application;
            this.showDetailsDialog = true;
            this.loadingDetails = true;
            // Reset to trigger reactivity
            this.$set(this, 'applicationDetails', {});
            
            try {
                // Get the first student to extract project_code and student_id
                const student = this.students && this.students.length > 0 ? this.students[0] : null;
                if (!student) {
                    this.$message.error('Student information not available');
                    this.loadingDetails = false;
                    return;
                }
                
                const project_code = application.application_project;
                const student_id = student._id.$id;
                
                // Create API calls dynamically
                const { getApplicationDetails } = await import('../../api/assistant');
                const details = await getApplicationDetails(project_code, student_id);
                
                // Log the response to debug
                console.log('API Response:', details);
                console.log('Response data:', details.data);
                
                this.loadingDetails = false;
                
                // Ensure we have data and set it properly  
                console.log('details structure:', details);
                console.log('details.data structure:', details.data.data);
                
                if (details && details.data) {
                    // Set only the data portion, not the entire response
                    this.$set(this, 'applicationDetails', details.data.data);
                    console.log('Set applicationDetails to:', this.applicationDetails);
                    console.log('applicationDetails keys after set:', Object.keys(this.applicationDetails));
                } else {
                    this.$set(this, 'applicationDetails', {});
                    console.warn('No data received from API');
                }
                
            } catch (error) {
                console.error('Error loading application details:', error);
                this.$message.error('Failed to load application details');
                this.$set(this, 'applicationDetails', {});
                this.loadingDetails = false;
            }
        },
        
        formatCustomExamTime(timestamp) {
            if (!timestamp) return 'N/A';
            const date = new Date(timestamp * 1000);
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
        },
        
        formatTimestamp(timestamp) {
            if (!timestamp) return 'N/A';
            const date = new Date(timestamp * 1000);
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
        },

        // formartSender(emailInfo) {
        //     if (this.mail_type == 'in') {//收件箱
        //         if (emailInfo.email_type == 'from') {//发送给我们的
        //             return emailInfo.fromName + "(" + emailInfo.from + ")"
        //         } else { //我们发出去给他们的
        //              return emailInfo.fromName + "(" + emailInfo.from + ")"
        //         }
        //     } else {//发件箱

        //     }
        // },

        showEmailContent(emailInfo) {
            this.emailContent = emailInfo.content
            this.selectedEmailForContent = emailInfo
            this.showContentDialog = true
        },
        
        async setNoNeedToReply() {
            if (!this.selectedEmailForContent || !this.selectedEmailForContent._id) {
                this.$message.warning('Unable to update email status')
                return
            }
            
            this.settingNoReply = true
            try {
                const { updateMailReplyStatus } = await import('../../api/assistant')
                const res = await updateMailReplyStatus(this.selectedEmailForContent._id.$id, -1)
                
                if (res && res.data) {
                    // Update the email in the history list
                    const index = this.mailHistoryData.findIndex(
                        email => email._id.$id === this.selectedEmailForContent._id.$id
                    )
                    if (index !== -1) {
                        this.mailHistoryData[index] = res.data
                    }
                    
                    // Recalculate pending count
                    this.calculatePendingReplyCount()
                    
                    this.$message.success('Email marked as "No Need to Reply"')
                    this.showContentDialog = false
                }
            } catch (error) {
                console.error('Error updating email status:', error)
                this.$message.error('Failed to update email status')
            } finally {
                this.settingNoReply = false
            }
        },
        
        getStatusText(emailInfo) {
            if (!emailInfo.send_type) { // This is a received email
                if (emailInfo.reply_status === -1) {
                    return 'No Need to Reply'
                } else if (emailInfo.reply_status && emailInfo.reply_status > 0) {
                    return 'Replied'
                } else if (emailInfo.assigned_user_id && emailInfo.assigned_user_id !== -1) {
                    return 'Assigned'
                } else {
                    return 'Pending Reply'
                }
            } else { // This is a sent email
                return 'Sent'
            }
        },
        
        getStatusTagType(emailInfo) {
            if (!emailInfo.send_type) { // This is a received email
                if (emailInfo.reply_status === -1) {
                    return 'info'
                } else if (emailInfo.reply_status && emailInfo.reply_status > 0) {
                    return 'success'
                } else if (emailInfo.assigned_user_id && emailInfo.assigned_user_id !== -1) {
                    return 'warning'
                } else {
                    return 'danger'
                }
            } else { // This is a sent email
                return ''
            }
        },
        
        calculatePendingReplyCount() {
            this.pendingReplyCount = this.mailHistoryData.filter(email => {
                // Count emails that are received (not sent) and pending reply
                return !email.send_type && 
                       (!email.reply_status || email.reply_status === 0) && 
                       email.reply_status !== -1
            }).length
        },

        formatMailDate(mail) {
            const create_time = mail.create_time
            const date = new Date(create_time * 1000)
            const utc = date.getTime() + date.getTimezoneOffset() * 60000
            const nd = new Date(utc + 8 * 60 * 60 * 1000)
            return formatDate(nd, 'yyyy-MM-dd hh:mm:ss')
        },
        async handleMailChanged() {
            if (this.mail_id && this.mail_id != '') {
                let res = await getEmailHistoryByFromEmail(this.mail_id, this.mail_type)
                this.mailHistoryData = res.data.data
                this.calculatePendingReplyCount()
            } else {
                this.mailHistoryData = []
                this.pendingReplyCount = 0
            }
        },
        handleClientData() {
            this.contacts = []
            this.students = []
            this.applications = []
            this.accountApps = {}

            if (this.clientData.contacts && this.clientData.contacts.length > 0) {
                this.contacts = this.clientData.contacts
            }

            if (this.clientData.students && this.clientData.students.length > 0) {
                this.students = this.clientData.students
            }

            if (this.clientData.students && this.clientData.students.length > 0) {
                let firstItem = this.clientData.students[0]
                if (firstItem.applications && firstItem.applications.length > 0) {
                    this.applications = firstItem.applications
                }
            }

            if (this.clientData.account_apps && Object.keys(this.clientData.account_apps).length > 0) {
                this.accountApps = this.clientData.account_apps
            }
        }
    }
})
</script>
<style lang="scss" scoped>
.el-tabs__item {
    padding: 0 10px;
    /* 设置左右间距 */
}

.table-container {
    width: 100%;

    .table-item {
        width: 100%;
        padding: 6px 12px;
        box-sizing: border-box;
        margin-bottom: 10px;
        color: #333;
        font-size: 14px;
        background-color: #FFD9D4;
        border-radius: 5px;
    }
}

.details-section {
    background-color: #f8f9fa;
    padding: 12px;
    border-radius: 5px;
    margin-bottom: 15px;
    
    .detail-item {
        background-color: white;
        padding: 8px 12px;
        border-radius: 4px;
        margin-bottom: 8px;
        border-left: 3px solid #409eff;
        
        &:last-child {
            margin-bottom: 0;
        }
        
        p {
            margin: 4px 0;
            font-size: 14px;
            
            strong {
                color: #303133;
            }
        }
    }
}
</style>